module.exports = {"name":"Showcase","icon":"<i class='material-icons'>view_compact</i>","widget":[{"type":"showcase","initData":{"tags":[],"limit":6}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/showcase/showcase.json
// module id = 393
// module chunks = 0